import React from 'react';
import { HomePageHeroSectionProps } from '../../../../../Sections/HomePage/HeroSection/HeroSection';
import * as classes from './HeroSection.module.scss';
import Container from '../../../../../Common/Container/Container';
import SectorsList from '../../../Components/SectorsList/SectorsList';
import HeroSectionLinks from '../../../Components/HeroSectionLinks/HeroSectionLinks';
import cn from 'classnames';
import PhoneIcon from '../../../../../../assets/icons/inline/phone-circle.inline.svg';
import CalendarIcon from '../../../../../../assets/icons/inline/calendar-circle.inline.svg';
import Link from '../../../../../Common/Link/Link';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const HeroSection = ({ longTitle, sectorsList, address, userAvatar, phoneNumber }: HomePageHeroSectionProps) => {
  const { t } = useTranslation();
  return (
    <section className={classes.wrapper} data-aos='fade-in'>
      <Container>
        <div className={'row'}>
          <div className={cn('col-md-5 col-lg-6', classes.infoWrapper)}>
            <h1 className={classes.title} data-aos='fade-in' data-aos-delay='500'>
              {longTitle}
            </h1>
            <div className={classes.address} data-aos='fade-in' data-aos-delay='500'>
              {address}
            </div>
            <div data-aos='fade-in' data-aos-delay='500'>
              <SectorsList items={sectorsList} />
            </div>
          </div>
        </div>
      </Container>
      <div className={classes.bgBlock} />
      <HeroSectionLinks />
      {userAvatar && (
        <div className={classes.avatarWrapper} style={{ backgroundImage: `url(${userAvatar})` }} data-aos='fade-in' data-aos-delay='500' />
      )}
      {phoneNumber && (
        <a href={`tel:${phoneNumber}`}>
          <div className={cn(classes.phone, classes.mobileBlocks)}>
            <PhoneIcon />
            <div>{phoneNumber}</div>
          </div>
        </a>
      )}
      <Link path={t('homePage.heroSection.bookAnAppointmentButton.url')} title={t('homePage.heroSection.bookAnAppointmentButton.title')}>
        <div className={cn(classes.calendar, classes.mobileBlocks)}>
          <CalendarIcon />
          <div>{t('homePage.heroSection.bookAnAppointmentButton.label')}</div>
        </div>
      </Link>
    </section>
  );
};

export default HeroSection;
